import { CommonModule, JsonPipe } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbDateParserFormatter, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { CustomDateParserFormatter } from '../../Util/DateFormat/date-format.service';
import { SupportTicketService } from '../../Model/Support/support-ticket.service';
import { CommonService } from '../../Model/Common/common.service';
import { SessionService } from '../../Util/Session/session.service';
import { SupportTicketFormComponent } from '../support-ticket-form/support-ticket-form.component';
import { UtilityService } from '../../Model/utility/utility.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { ComboService } from '../../Model/Combo/combo.service';

@Component({
  selector: 'app-support-ticket',
  standalone: true,
  imports: [NgbModule, FormsModule, NgSelectModule, CommonModule, DataTablesModule, JsonPipe, LoaderComponent],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './support-ticket.component.html',
  styleUrl: './support-ticket.component.scss'
})
export class SupportTicketComponent {
  isDisabled: boolean = false;
  showDate: boolean = false;
  TickecStatus: any = 'Assigned';
  dtTrigger: Subject<any> = new Subject<any>();
  FromDate: any = null;
  FromDateObj: any = null;
  ToDate: any = null;
  ToDateObj: any = null;
  public User: any = null;
  SupportData: any[] = [];

  Count: any[] = []
  Total: number = 0
  Close: number = 0
  //Open: number = 0
  Resolved: number = 0
  Assigned: number = 0

  // globalCount: any[] = []
  globalTotal: number = 0
  globalClose: number = 0
  globalAssign: number = 0
  globalResolved: number = 0

  Branchs: any[] = [];
  Clients: any[] = [];
  Supervisors: any[] = [];
  Sites: any[] = [];

  ComplaintTypeData: any[] = [];
  ESS_ComplaintTypeId: any = null;

  Filter = {
    BranchID: [],
    ClientID: [],
    SiteOwnerID: [],
    SiteID: []
  }


  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;

  selectedMonth: any = null;
  startFromDate: any = null
  startToDate: any = null

  constructor(
    private support: SupportTicketService,
    private dateFormate: CustomDateParserFormatter,
    protected common: CommonService,
    private sessionService: SessionService,
    private modalService: NgbModal,
    private utility: UtilityService,
    private toast: ToastService,
    private combo: ComboService,
  ) {
    this.User = this.sessionService.GetUserDetails();
    this.common.getPageRights();
  }

  curDate() {
    const currentDate = new Date();
    const FromDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    const ToDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
    const formatDate = (date: Date) => ({
      day: date.getDate(),
      month: date.getMonth() + 1,
      year: date.getFullYear(),
    });
    this.FromDate = formatDate(FromDate);
    this.ToDate = formatDate(ToDate);
  }
  ngOnInit(): void {
    this.curDate();
    this.getData();
    this.CountData('All');
    this.ComboLoad('ComplaintType');
    this.ComboLoad2('Branch');
    this.ComboLoad2('SiteOwner');
  }
  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  getData() {
    this.SupportData = [];
    this.FromDateObj = this.dateFormate.format(this.FromDate);
    this.ToDateObj = this.dateFormate.format(this.ToDate);
    const Detail = {
      SelectType: 'W',
      EmpMasterId: '',
      UserId: this.User.UserId,
      Status: this.TickecStatus,
      FromDate: this.showDate ? this.startFromDate : this.FromDateObj,
      ToDate: this.showDate ? this.startToDate : this.ToDateObj,
      BranchId: this.Filter.BranchID.toString(),
      ClientId: this.Filter.ClientID.toString(),
      SiteId: this.Filter.SiteID.toString(),
      SiteSupervisorId: this.Filter.SiteOwnerID.toString(),
      ESS_ComplaintTypeId: this.ESS_ComplaintTypeId,
      HelpDeskUserType: 'User'
    }
    this.isDisabled = true;
    this.support.ESS_HelpDeskRequest(Detail).subscribe({
      next: (data) => {
        this.SupportData = Object.values(data.Table);
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.Total = this.SupportData.length;
        //this.Open = this.SupportData.filter(item => item.Status.toLowerCase() === 'open').length;
        this.Close = this.SupportData.filter(item => item.Status.toLowerCase() === 'closed').length;
        this.Resolved = this.SupportData.filter(item => item.Status.toLowerCase() === 'resolved').length;
        this.Assigned = this.SupportData.filter(item => item.Status.toLowerCase() === 'assigned').length;
        this.CountData('All')
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        console.error('Error:', error);
        this.isDisabled = false;
      },
    });
  }

  onEditClick(element: any) {
    const modalRef = this.modalService.open(SupportTicketFormComponent, { centered: true, backdrop: 'static', size: 'xl' });
    modalRef.componentInstance.InputData = {
      SelectType: 'U',
      ESS_HelpDeskRequestId: element.ESS_HelpDeskRequestID,
      ESS_ComplaintTypeId: element.ESS_ComplaintTypeId,
      AdditionalDetails: element.AdditionalDetails,
      EmpMasterId: element.EmpMasterId,
      ContactNo: element.ContactNo,
      Description: element.Description,
      UserId: this.User.UserId,
      ComplaintType: element.ComplaintType,
      EmpName: element.EmpName,
      EmpCode: element.EmpCode,
      EmpEmail: element.EmpEmail,
      EmpContact: element.EmpContact,
      BranchName: element.BranchName,
      ClientLocation: element.ClientLocation,
      SiteName: element.SiteName,
      SiteSuperVisorName: element.SiteSuperVisorName,
      SupervisorEmailId: element.SupervisorEmailId,
      SupervisorContactNo: element.SupervisorContactNo,
      DesignationName: element.DesignationName,
      Photo: element.Photo,
      Status: element.Status,
      type: 'Resolved',
      Attachment:element.Attachment,
    };
    modalRef.result.then((result) => {
      if (result) {
        this.SupportData = [];
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.getData();
        //window.location.reload();
      }
    }).catch((reason) => {
      console.log('Modal dismissed:', reason);
    });
  }

  CountData(Status: string) {
    const Detail = {
      SelectType: 'W',
      EmpMasterId: '',
      UserId: this.User.UserId,
      Status: Status,
      FromDate: null,
      ToDate: null,
      BranchId: this.Filter.BranchID.toString(),
      ClientId: this.Filter.ClientID.toString(),
      SiteId: this.Filter.SiteID.toString(),
      SiteSupervisorId: this.Filter.SiteOwnerID.toString(),
      ESS_ComplaintTypeId: this.ESS_ComplaintTypeId,
      HelpDeskUserType: 'User'
    }
    this.support.ESS_HelpDeskRequest(Detail).subscribe({
      next: (data) => {  
        this.Count = data.Table;
        if (this.Count.length > 0) {
          this.globalTotal = this.Count.length;
          this.globalAssign = this.Count.filter(item => item.Status.toLowerCase() === 'assigned').length;
          this.globalClose = this.Count.filter(item => item.Status.toLowerCase() === 'closed').length;
          this.globalResolved = this.Count.filter(item => item.Status.toLowerCase() === 'resolved').length;          
        }
      },
      complete: () => {
      },
      error: (error) => {
        console.error('Error:', error);
        this.isDisabled = false;
      },
    });
  }

  CardCountFilter(type: string) {
    this.SupportData = [];
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
    this.TickecStatus = type;
    this.getData();
    // const Detail = {
    //   SelectType: 'W',
    //   EmpMasterId: '',
    //   UserId: this.User.UserId,
    //   Status: this.TickecStatus,
    //   FromDate: '',//this.showDate ? this.startFromDate : this.FromDateObj,
    //   ToDate: '',//this.showDate ? this.startToDate : this.ToDateObj
    // }
    // this.isDisabled = true;
    // this.support.ESS_HelpDeskRequest(Detail).subscribe({
    //   next: (data) => {
    //     this.SupportData = data.Table;
    //     this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
    //       dtInstance.destroy();
    //       this.dtTrigger.next(null);
    //     });
    //     this.CountData('All')
    //     this.isDisabled = false;
    //   },
    //   complete: () => {
    //   },
    //   error: (error) => {
    //     console.error('Error:', error);
    //     this.isDisabled = false;
    //   },
    // });
  }
  ComboLoad2(Combotype: String) {
    this.isDisabled = true;
    if (true || (Combotype == 'Region') ||
      (Combotype == 'Branch') ||
      (Combotype == 'Client' && this.Filter.BranchID.length > 0) ||
      (Combotype == 'Site' && this.Filter.ClientID.length > 0) ||
      (Combotype == 'SiteOwner')) {
      this.support.ComboLoad({
        'SelectType': Combotype,
        'BranchId': this.Filter.BranchID.toString(),
        'ClientId': this.Filter.ClientID.toString(),
        'SiteId': this.Filter.SiteID.toString(),
        //'SupervisorId': this.Filter.SiteOwnerID.toString(),
        'UserId': this.User.UserId,
      }).subscribe({
        next: (response) => {
          if (Combotype == 'Branch') {
            this.Branchs = response.Table;
          } else if (Combotype == 'Client') {
            this.Clients = response.Table;
          } else if (Combotype == 'SiteOwner') {
            this.Supervisors = response.Table;
          } else if (Combotype == 'Site') {
            this.Sites = response.Table;
          }
          this.isDisabled = false;
        },
        complete: () => {
        },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    } else {
      this.isDisabled = false;
    }
  }

  ComboLoad(Combotype: String, Combotype2: string = '', index = 0) {
    this.isDisabled = true;
    this.combo.ComboLoad({
      'Combotype': Combotype,
    }).subscribe({
      next: (response) => {
        if (Combotype == 'ComplaintType') {
          this.ComplaintTypeData = response.ComboLoad;
          this.isDisabled = false
        }
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
  Validate(form: any) {
    if (form.valid) {
      this.SupportData = [];
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
      this.getData();
    } else {
      form.submitted = true;
    }
  }

  onNavigate() {
    const startFromDate = new Date(this.selectedMonth.year, this.selectedMonth.month - 1, 1);
    const endDate = new Date(this.selectedMonth.year, this.selectedMonth.month, 0);
    this.startFromDate = startFromDate.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
    this.startToDate = endDate.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  }

  onchange(type: string) {
    if (type === 'ComplaintType') {
      this.SupportData = []
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } else if (type === 'Status') {
      this.SupportData = []
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } else if (type === 'Date') {
      this.SupportData = []
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } else if (type === 'Branch') {
      this.SupportData = [];
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
      this.Filter.ClientID = []
      this.Clients = [];
      this.Filter.SiteID = [];
      this.Sites = []
    } else if (type === 'Client') {
      this.SupportData = [];
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
      this.Filter.SiteID = [];
      this.Sites = []
    } else if (type === 'site') {
      this.SupportData = []
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } else if (type === 'supervisor') {
      this.SupportData = []
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    }
  }

  Link(Text: string) {
    return this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + 'HelpDeskSupport' + '/' + Text;
  }
}
